module.exports = __webpack_public_path__ + "static/linguamillDesktop@2x-241cb1582859d951b8f8047b0c172668.jpg";